import { useYScale, useDrawingArea } from '@mui/x-charts-pro';
import { alpha, Stack, Typography } from '@mui/material';
import { colorFromNumber, icons, isContinuousScale } from './TachographDiagramTypes';

export function LineChartYIcons({
  isPhoneView,
  summaryValue,
}: {
  isPhoneView: boolean;
  summaryValue: (value: number) => string;
}) {
  const yScaleUnknown = useYScale();
  const { left } = useDrawingArea();

  const yIconFor = (raw: number) => {
    const svg = icons[raw];
    return svg ? { svg, size: 20 } : null;
  };

  let ticks: number[] = [];
  if (!isContinuousScale(yScaleUnknown)) {
    return null;
  }
  const yScale = yScaleUnknown;
  ticks = yScale.ticks(5);

  return (
    <g pointerEvents="none" aria-hidden>
      {ticks.map((v) => {
        if (!isContinuousScale(yScaleUnknown)) {
          return null;
        }
        const baseY = yScaleUnknown(v);

        const spec = yIconFor(v);
        if (!spec) return null;

        const size = spec.size ?? 12;
        const href = `data:image/svg+xml;utf8,${encodeURIComponent(spec.svg)}`;

        const offsetX = isPhoneView ? 20 : -40;
        const offsetY = isPhoneView ? 2 : size / 2;
        const additionalHeight = isPhoneView ? 5 : 0;
        const additionalWidth = isPhoneView ? 48 : 0;
        const x = left + offsetX - size;
        const calculatedOffsetY = offsetY ?? size / 2;

        return (
          <foreignObject
            key={`yicon-${String(v)}`}
            x={x}
            y={baseY - calculatedOffsetY}
            width={size + additionalWidth}
            height={size + additionalHeight}
          >
            <Stack
              direction="row"
              sx={{
                borderRadius: 2,
                backgroundColor: alpha('#fff', 0.9),
                px: isPhoneView ? 0.5 : 0,
                alignItems: 'center',
              }}
              spacing={1}
            >
              <img src={href} width={size} height={size} />
              {isPhoneView && (
                <Typography variant="caption" fontWeight="bold" color={colorFromNumber[v]}>
                  {summaryValue(v)}
                </Typography>
              )}
            </Stack>
          </foreignObject>
        );
      })}
    </g>
  );
}
